<template>
  <v-list>
    <v-list-tile
      v-for="activity in activities" :key="activity.id"
      router :href="activity.user ? { name: 'User', params: { id: activity.user.id, tab: 'profile' } } : '#'">
      <v-list-tile-content>
        <v-list-tile-title>{{ $t(`activities.type.${activity.action}`, data(activity)) }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="activity.admin || activity.reason">
          <span v-if="activity.admin">{{ activity.admin.nickname }}</span>
          <span v-if="activity.reason">- {{ activity.reason }}</span>
          <span v-if="activity.data">- {{ Object.keys(activity.data).map(x => `${x}: ${activity.data[x]}`).join(', ') }}</span>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title v-else>
          {{ $t(`activities.reason.${activity.action}`, data(activity)) }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <Date class="caption" :value="activity.created_at" format="minimal"></Date>
      </v-list-tile-action>
    </v-list-tile>
    <v-list-tile v-if="pagination.page > 1 || pagination.nextPage || loading">
      <v-list-tile-action>
        <v-btn v-if="pagination.page > 1" icon @click.native.stop="prevPage()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content justify-center align-center>
        <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn v-if="pagination.nextPage" icon @click.native.stop="nextPage()">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/mixins/pagination'
import { Date } from '@/components/formatters'
export default {
  components: {
    Date
  },
  props: {
    userId: {
      type: Number,
      default: null
    },
    adminId: {
      type: Number,
      default: null
    }
  },
  mixins: [
    pagination('skiliko/activities')
  ],
  data () {
    return {
      filter: {
        user_id: this.userId,
        admin_id: this.adminId,
        page: 1,
        per_page: 10
      }
    }
  },
  computed: mapGetters({
    platform: 'skiliko/session/currentPlatform'
  }),
  methods: {
    prevPage () {
      this.filter = {
        ...this.filter,
        page: this.filter.page - 1
      }
    },
    nextPage () {
      this.filter = {
        ...this.filter,
        page: this.filter.page + 1
      }
    },
    data (activity) {
      return {
        ...activity.data,
        nickname: activity.user ? activity.user.nickname : '',
        amount: activity.data ? activity.data.amount / 100 : null,
        currency: this.platform.currency
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Activities.vue